import { AuthenticatorFormFields } from './AuthenticatorFormFields';
import { AuthenticatorComponent } from './AuthenticatorComponent';
import {
    ConfirmSignInInput,
    ConfirmSignInOutput,
    confirmSignIn,
    signIn,
} from 'aws-amplify/auth';
import { AuthenticatorProps } from '@aws-amplify/ui-react';

export const authenticatorSettings = {
    services: {
        // サインイン時の処理
        async handleSignIn({ username, password, options }) {
            try {
                const signInResult = await signIn({
                    username,
                    password,
                    options: {
                        ...options,
                        authFlowType: 'USER_SRP_AUTH',
                    },
                });
                return signInResult;
            } catch (error) {
                console.log({ error });
                throw error;
            }
        },

        // @ts-ignore
        async handleForceChangePassword(input: ConfirmSignInInput) {
            const result = await confirmSignIn(input);
            return result;
        },

        // mfa認証時の処理
        async handleConfirmSignIn({
            challengeResponse,
        }): Promise<ConfirmSignInOutput> {
            const signInResult = await confirmSignIn({
                challengeResponse,
            });
            if (!signInResult.isSignedIn) {
                throw new Error(
                    '認証コードが間違っています。もう一度正確な認証コードを入力してください。認証コードを再送信しました。お手数ですが、受信ボックスを確認してください。'
                );
            }
            return signInResult;
        },
    },
    formFields: AuthenticatorFormFields,
    components: AuthenticatorComponent,
    hideSignUp: true,
} as const satisfies AuthenticatorProps;
